var $d8d3646556c40586$exports = {};
$d8d3646556c40586$exports = {
  "dragDescriptionKeyboard": "Nyomja le az Enter billenty\u0171t a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionKeyboardAlt": "Nyomja le az Alt + Enter billenty\u0171ket a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionLongPress": "Hosszan nyomja meg a h\xFAz\xE1s elind\xEDt\xE1s\xE1hoz.",
  "dragDescriptionTouch": "Koppintson dupl\xE1n a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionVirtual": "Kattintson a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragItem": function dragItem(args) {
    return "".concat(args.itemText, " h\xFAz\xE1sa");
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      }
    }), " h\xFAz\xE1sa");
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Nyomja meg az Entert ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      }
    }), " h\xFAz\xE1s\xE1hoz.");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Nyomja meg az Alt + Enter billenty\u0171ket ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      }
    }), " h\xFAz\xE1s\xE1hoz.");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Tartsa lenyomva hosszan ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " kijel\xF6lt elem");
      }
    }), " h\xFAz\xE1s\xE1hoz.");
  },
  "dragStartedKeyboard": "H\xFAz\xE1s megkezdve. Nyomja le a Tab billenty\u0171t az elenged\xE9si c\xE9lhoz navig\xE1l\xE1s\xE1hoz, majd nyomja le az Enter billenty\u0171t az elenged\xE9shez, vagy nyomja le az Escape billenty\u0171t a megszak\xEDt\xE1shoz.",
  "dragStartedTouch": "H\xFAz\xE1s megkezdve. Navig\xE1ljon egy elenged\xE9si c\xE9lhoz, majd koppintson dupl\xE1n az elenged\xE9shez.",
  "dragStartedVirtual": "H\xFAz\xE1s megkezdve. Navig\xE1ljon egy elenged\xE9si c\xE9lhoz, majd kattintson vagy nyomja le az Enter billenty\u0171t az elenged\xE9shez.",
  "dropCanceled": "Elenged\xE9s megszak\xEDtva.",
  "dropComplete": "Elenged\xE9s teljes\xEDtve.",
  "dropDescriptionKeyboard": "Nyomja le az Enter billenty\u0171t az elenged\xE9shez. Nyomja le az Escape billenty\u0171t a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "dropDescriptionTouch": "Koppintson dupl\xE1n az elenged\xE9shez.",
  "dropDescriptionVirtual": "Kattintson az elenged\xE9shez.",
  "dropIndicator": "elenged\xE9sjelz\u0151",
  "dropOnItem": function dropOnItem(args) {
    return "Elenged\xE9s erre: ".concat(args.itemText);
  },
  "dropOnRoot": "Elenged\xE9s erre:",
  "endDragKeyboard": "H\xFAz\xE1s folyamatban. Nyomja le az Enter billenty\u0171t a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "endDragTouch": "H\xFAz\xE1s folyamatban. Koppintson dupl\xE1n a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "endDragVirtual": "H\xFAz\xE1s folyamatban. Kattintson a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "insertAfter": function insertAfter(args) {
    return "Besz\xFAr\xE1s ".concat(args.itemText, " ut\xE1n");
  },
  "insertBefore": function insertBefore(args) {
    return "Besz\xFAr\xE1s ".concat(args.itemText, " el\xE9");
  },
  "insertBetween": function insertBetween(args) {
    return "Besz\xFAr\xE1s ".concat(args.beforeItemText, " \xE9s ").concat(args.afterItemText, " k\xF6z\xE9");
  }
};
export { $d8d3646556c40586$exports as default };